import {
  clearTimeouts,
  engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format, templateName, data } = props;

  const timeline = anime.timeline();

  const templateDuration = 10;

  $(`#${id} .ant-progress-bg`).css("width", "100%");
  $(`#${id} .ant-progress-bg`).css(
    "transition-duration",
    `${templateDuration}s`,
  );

  $(
    `#${id} .layer-positions .shot, #${id} .layer-shots .shot, #${id} .stat-row`,
  ).css("opacity", 0);

  const timeout1 = setTimeout(() => {
    anime({
      targets: [`#${id} .layer-shots .shot.color-goal`],
      duration: 800,
      easing: "easeInOutCubic",
      translateY: [1200, 0],
      skewY: ["60deg", 0],
      opacity: [1, 1],
      delay: anime.stagger(200),
      complete: () => {
        anime({
          targets: [`#${id} .layer-shots .shot:not(.color-goal)`],
          duration: 800,
          easing: "easeInOutCubic",
          translateY: [1200, 0],
          skewY: ["60deg", 0],
          opacity: [1, 1],
          delay: anime.stagger(100),
          complete: () => {
            anime({
              targets: [`#${id} .goalmouth-content`],
              duration: 800,
              easing: "easeOutQuint",
              opacity: [1, 0],
              delay: 100,
              complete: () => {
                anime({
                  targets: [`#${id} .field-content`],
                  duration: 800,
                  easing: "easeOutQuint",
                  opacity: [0, 1],
                  delay: 100,
                  complete: () => {
                    anime({
                      targets: [`#${id} .layer-positions .shot.color-goal`],
                      duration: 800,
                      easing: "easeInOutCubic",
                      translateY: [1200, 0],
                      skewY: ["60deg", 0],
                      opacity: [1, 1],
                      delay: anime.stagger(100),
                      complete: () => {
                        anime({
                          targets: [`#${id} .layer-positions .shot:not(.color-goal)`],
                          duration: 1000,
                          easing: "easeInOutCubic",
                          translateY: [1200, 0],
                          skewY: ["60deg", 0],
                          opacity: [1, 1],
                          delay: anime.stagger(100),
                        });
                      },
                    });
                  }
                });
              }
            });
          }
        });
      },
    });
  }, 500);

  anime({
    targets: [`#${id} .stat-row`],
    duration: 1000,
    easing: "easeOutQuint",
    opacity: [0, 1],
    delay: 1000,
  });

  timeouts.push(timeout1);

  return {
    timeline: [],
    timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
